import {Injectable} from '@angular/core';
import {Observable, of} from 'rxjs';
import {HttpClient, HttpParams, HttpResponse} from '@angular/common/http';
import {NameValueDto} from '@ig-core/interfaces/name-value-dto';
import {map,share} from 'rxjs/operators'
import { LoanProduct, ProductMaster } from '@app/applications/applications.model';
import { RecentOpenedApplicationsService } from '@app/applications/recent-opened-applications.service';
import { ReferenceCode, ReferenceCodeSearchCriteria } from '../reference-code/reference-code.model';
@Injectable({
    providedIn: 'root'
})
export class DataSourceService {

  // entityCreatedDate will have the application created date, i.e., applicationDate.
  // This date is used for comparison with the inactiveDate in the reference code.
  // The purpose is to determine whether to include the corresponding data in the response.
  entityCreatedDate: Date;

    private API = 'api/reference-codes';

    constructor(private http: HttpClient) {}


    findXdataRequest(applicationUid, requestType) {
      let params = new HttpParams();
      if (requestType != undefined && requestType != null && requestType !=  "") {
        params = params.set('requestType', requestType);
    }
        return this.http.get<any>('api/v1/applications/' + applicationUid + '/xdatarequests', {params, observe: 'response'});
    }

    generateRequestFile(requestId: number): Observable<HttpResponse<Blob>> {
      return this.http.post('api/v1/applications/xdatarequests/' + requestId + '/downloadRequest',null,
        { observe: 'response', responseType: 'blob'}
      )
    }

}

